import ToolsOfTheFirstBuilders from '@/roc/museum/foundationsOfCivilization/ToolsOfTheFirstBuilders';
import StringsOfTheAncients from '@/roc/museum/foundationsOfCivilization/StringsOfTheAncients';
import WarriorsCrown from '@/roc/museum/foundationsOfCivilization/WarriorsCrown';
import VesselOfAthena from '@/roc/museum/foundationsOfCivilization/VesselOfAthena';
import GoddessOfVertility from '@/roc/museum/foundationsOfCivilization/GoddessOfFertility';
import BrustOfMarcusAurelius from '@/roc/museum/foundationsOfCivilization/BustOfMarcusAurelius';
import TragedyAndComedy from '@/roc/museum/foundationsOfCivilization/TragedyAndComedy';
import NebraDisc from '@/roc/museum/foundationsOfCivilization/NebraDisc';
import HobbleOfTheSea from '@/roc/museum/legendsOfTheHighSeas/HobbleOfTheSea';
import JollyRoger from '@/roc/museum/legendsOfTheHighSeas/JollyRoger';
import HiddenHoard from '@/roc/museum/legendsOfTheHighSeas/HiddenHoard';
import CaptainsHat from '@/roc/museum/legendsOfTheHighSeas/CaptainsHat';
import DrakesFirearm from '@/roc/museum/legendsOfTheHighSeas/DrakesFirearm';
import BonnysBlade from '@/roc/museum/legendsOfTheHighSeas/BonnysBlade';
import CorsairsSkull from '@/roc/museum/legendsOfTheHighSeas/CorsairsSkull';
import PharaohsGold from '@/roc/museum/treasuresOfTheNile/PharaosGold';
import AmuletOfKhepri from '@/roc/museum/treasuresOfTheNile/AmuletOfKhepri';
import AnubisSarcophagus from '@/roc/museum/treasuresOfTheNile/AnubisSarcophagus';
import IdolOfBastet from '@/roc/museum/treasuresOfTheNile/IdolOfBastet';
import KeyOfLife from '@/roc/museum/treasuresOfTheNile/KeyOfLife';
import BronzeShellCoins from '@/roc/museum/whispersOfJade/BronzeShellCoins';
import LotusShoes from '@/roc/museum/whispersOfJade/LotusShoes';
import TheArtOfChaDao from '@/roc/museum/whispersOfJade/TheArtOfChaDao';
import WhispersOfTheInk from '@/roc/museum/whispersOfJade/WhispersOfTheInk';
import LoongSymbol from '@/roc/museum/whispersOfJade/LoongSymbol';
import NorseHoard from '@/roc/museum/echoesOfTheNorth/NorseHoard';
import WeaponsOfValhalla from '@/roc/museum/echoesOfTheNorth/WeaponsOfValhalla';
import StringsOfTheSkald from '@/roc/museum/echoesOfTheNorth/StringsOfTheSkald';
import RavenHelm from '@/roc/museum/echoesOfTheNorth/RavenHelm';
import ProwOfVinland from '@/roc/museum/echoesOfTheNorth/ProwOfVinland';
import AchillesArmor from '@/roc/museum/legendsOfTroy/AchillesArmor';
import HectorSword from '@/roc/museum/legendsOfTroy/HectorSword';
import HelenDress from '@/roc/museum/legendsOfTroy/HelenDress';
import PriamDiadem from '@/roc/museum/legendsOfTroy/PriamDiadem';
import TrojanHorseHead from '@/roc/museum/legendsOfTroy/TrojanHorseHead';
import EccentricFlint from '@/roc/museum/underTheCeiba/EccentricFlint';
import BloodlettingStingraySpine from '@/roc/museum/underTheCeiba/BloodlettingStingraySpine';
import XocolatlDrinkingCup from '@/roc/museum/underTheCeiba/XocolatlDrinkingCup';
import KingPakalMask from '@/roc/museum/underTheCeiba/KingPakalMask';
import MayaCodexOfMexico from '@/roc/museum/underTheCeiba/MayaCodexOfMexico';
import TorpedoJar from '@/roc/museum/pathsOfIncense/TorpedoJar';
import BronzeDromedaryStatue from '@/roc/museum/pathsOfIncense/BronzeDromedaryStatue';
import ArabianOstrichEggContainer from '@/roc/museum/pathsOfIncense/ArabianOstrichEggContainer';
import IlkhanicTables from '@/roc/museum/pathsOfIncense/IlkhanicTables';
import QueenArwaDinar from '@/roc/museum/pathsOfIncense/QueenArwaDinar';
const Artifacts = [
    WarriorsCrown,
    StringsOfTheAncients,
    VesselOfAthena,
    GoddessOfVertility,
    ToolsOfTheFirstBuilders,
    BrustOfMarcusAurelius,
    TragedyAndComedy,
    NebraDisc,
    CaptainsHat,
    HiddenHoard,
    JollyRoger,
    HobbleOfTheSea,
    DrakesFirearm,
    BonnysBlade,
    CorsairsSkull,
    PharaohsGold,
    AmuletOfKhepri,
    AnubisSarcophagus,
    IdolOfBastet,
    KeyOfLife,
    LotusShoes,
    BronzeShellCoins,
    WhispersOfTheInk,
    TheArtOfChaDao,
    LoongSymbol,
    NorseHoard,
    WeaponsOfValhalla,
    StringsOfTheSkald,
    RavenHelm,
    ProwOfVinland,
    AchillesArmor,
    HectorSword,
    PriamDiadem,
    HelenDress,
    TrojanHorseHead,
    EccentricFlint,
    BloodlettingStingraySpine,
    XocolatlDrinkingCup,
    KingPakalMask,
    MayaCodexOfMexico,
    TorpedoJar,
    BronzeDromedaryStatue,
    ArabianOstrichEggContainer,
    IlkhanicTables,
    QueenArwaDinar,
];
export default Artifacts;
